import assign from 'lodash/assign';
import get from 'lodash/get';

import template from './statusSummary.html';
import './statusSummary.scss';

export const StatusSummaryModule = angular
    .module('app.components.statusPage.statusSummary', [])
    .component('statusSummary', {
        template,
        controller: class StatusSummaryController {
            constructor($http) {
                'ngInject';

                assign(this, {
                    pageId: 'volusion',
                    statusText: null,
                    $http,
                    statusLabels: {
                        operational: 'All Systems Operational',
                        major_outage: 'Major Outage',
                        partial_outage: 'Partial Outage',
                        degraded_performance: 'Degraded Performance',
                        under_maintenance: 'Under Maintenance'
                    }
                });
            }

            $onInit() {
                this.getStatusSummary().then((response) => {
                    const components = get(response, 'data.components', []);
                    const v2Component = components.find(c => c.name === 'V2');

                    if (v2Component) {
                        this.indicator = v2Component.status;
                        this.statusText = v2Component.description || this.statusLabels[v2Component.status];
                    }
                });
            }

            getStatusSummary() {
                return this.$http({
                    method: 'GET',
                    url: `https://${this.pageId}.statuspage.io/api/v2/summary.json`
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/statusPage/statusSummary.component.js